import { MARQUEE_ITEMS } from "../data/content";

const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-ribbon-marquee"
      className="relative overflow-hidden bg-[#0D3B3E] py-5 select-none"
      aria-hidden="true"
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-lg sm:text-xl text-[#F8FAF8]/90 px-6">{item}</span>
            <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-[#2DD4BF]" fill="currentColor">
              <path d="M12 2c1.5 5 4 7.5 9 9-5 1.5-7.5 4-9 9-1.5-5-4-7.5-9-9 5-1.5 7.5-4 9-9z" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
